import jsBridge from  '@tencent/nb-js-bridge';

export default jsBridge;
